import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Modal } from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../../../../App";
import { useSnackbar } from "../../product/hooks/SnackbarProvider";
import useGetDevice from "../../product/hooks/useGetDevice";
import { setReturnedItems } from "../../product/all-products/redux/Actions/paginationActions";
import { getReturnedProducts } from "../../product/all-products/redux/Reducers/paginationReducer";
import StyledButton from "../../product/all-products/components/custom/StyledButton";
import { debounce } from "lodash";
import PosCustomIcon from "../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { XCircleIcon } from "@heroicons/react/20/solid";
import { PosCustomButton } from "../../../../customComponents/PosCustomButton/PosCustomButton";

export const QuantityValidationModal = ({ show, onClose, content, setShowModal }) => {
  const [returnedQty, setReturnedQty] = useState(1);
  const returnItemArray = useSelector(getReturnedProducts);
  const { color } = useContext(UserContext);
  const dispatch = useDispatch();
  const isMobile = useGetDevice();
  const [disabled, setDisabled] = useState(false);
  const showSnackbar = useSnackbar();

  const handleReturnedProducts = () => {
    const existingItemIndex = returnItemArray?.findIndex(
      (item) => item?.gtin === content?.gtin && item?.batchNo === content?.batchNo
    );
    if (existingItemIndex !== -1) {
      const existingItem = returnItemArray?.[existingItemIndex];
      const newReturnedQty = Number(returnedQty);
      if (newReturnedQty <= content.quantity) {
        const updatedItem = { ...existingItem, returnedQty: newReturnedQty };
        const updatedReturnItemArray = [
          ...returnItemArray.slice(0, existingItemIndex),
          updatedItem,
          ...returnItemArray.slice(existingItemIndex + 1),
        ];

        dispatch(setReturnedItems(updatedReturnItemArray));
      } else {
        showSnackbar("Returned quantity exceeds original quantity", "error");
      }
    } else {
      dispatch(setReturnedItems([...returnItemArray, { ...content, returnedQty: returnedQty }]));
    }
    setShowModal(false);
  };

  const handleReturnedQuantity = (val, qty) => {
    if (Number(val) > Number(qty)) {
      setDisabled(true);
      showSnackbar("Cannot return more than the quantity available in your cart.", "error", 1000);
    } else if (Number(val) == 0 || val == "") {
      setDisabled(true);
      showSnackbar("Cannot return with 0 quantity.", "error", 1000);
    } else {
      setDisabled(false);
    }
  };

  const debouncedValidateReturnedQuantity = useMemo(
    () => debounce(handleReturnedQuantity, 500),
    []
  );

  const handleInputChange = (e) => {
    const val = e.target.value;
    // const qty = content?.weightsAndMeasures ? content?.quantityBySpecs : content?.quantity;
    const qty = content?.quantityBySpecs;
    setReturnedQty(val);
    debouncedValidateReturnedQuantity(val, qty);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.keyCode === 38 || e.keyCode === 40) {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Modal open={show} onClose={onClose}>
      <Box
        sx={{
          backgroundColor: color === "dark" ? "#353a50" : "#fff",
          color: color === "dark" ? "white" : "black",
          position: isMobile ? "static" : "relative",
          width: isMobile ? "100%" : "40%",
          maxWidth: "100vw",
          maxHeight: isMobile ? "100%" : "90%",
          transform: isMobile ? "none" : "translate(70%, -50%)",
          borderRadius: "6px",
          top: "50%",
          overflowY: "auto",
          ...(isMobile && {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }),
          padding: "1rem",
        }}
      >
        <div className="sticky-box-mrp-qualityVaildationModal">
          <div className="return-item-modal-heading-container">
            <p className="return-item-name-modal">Return Quantity</p>
            <PosCustomIcon
              icon={<XCircleIcon />}
              height={"20px"}
              width={"20px"}
              pointer={true}
              onClickFunction={onClose}
            />
          </div>
        </div>

        <div className="return-flex-box-container">
          <div className="return-flex-box">
            <p>Product Name </p>
            <p>{content?.productName}</p>
          </div>
          <div className="return-flex-box">
            <p>Barcode :</p>
            <p>{content?.gtin}</p>
          </div>
          <div className="return-flex-box">
            <p>Batch No:</p>
            <p>{content?.batchNo}</p>
          </div>
          <div className="return-flex-box">
            <p>MRP:</p>
            <p>₹{content?.mrp}</p>
          </div>
          <div className="return-flex-box">
            <p>Selling Price:</p>
            <p>₹{content?.sellingPrice}</p>
          </div>
        </div>

        <table className="quantity-modal-table">
          <thead>
            <tr>
              <th>Original Quanity</th>
              <th>Balance Quanity</th>
              <th>Return Quanity</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {/* <td>{content?.weightsAndMeasures ? content?.quantityBySpecs : content?.quantity}</td> */}
              <td>{content?.quantityBySpecs}</td>
              {/* <td>
                {returnedQty != 0
                  ? content?.weightsAndMeasures
                    ? Number(content?.quantityBySpecs) - Number(returnedQty)
                    : content?.quantity - Number(returnedQty)
                  : content?.weightsAndMeasures
                  ? content?.quantityBySpecs
                  : content?.quantity}
              </td> */}
              <td>
                {Number(
                  returnedQty != 0
                    ? content?.quantityBySpecs - Number(returnedQty)
                    : content?.quantityBySpecs
                ).toFixed(3)}
              </td>

              <td>
                <input
                  type="number"
                  autoFocus
                  value={returnedQty}
                  onChange={handleInputChange}
                  className="returned-qty-input"
                  onWheel={(e) => e.preventDefault()}
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div className="mrp-popup-box-quantityValidationModal">
          <PosCustomButton
            title="Cancel"
            variant="black-s"
            p={"12px 16px 12px 16px"}
            onClickFunction={onClose}
          />
          <PosCustomButton
            title="Proceed"
            variant="blue-d"
            disabled={disabled}
            p={"12px 16px 12px 16px"}
            onClickFunction={() => handleReturnedProducts()}
            border={true}
            width="100%"
          />
        </div>
      </Box>
    </Modal>
  );
};
